import { mobileApiRequest } from '../../apiRequests'

export const getReportSeriesMetadata = async (
    reportSeriesTableID,
    addCount = false,
    expandDateKeys = false
) => {
    const action = {
        action: 'getReportSeriesMetadata',
        addCount,
        reportSeriesTableID,
        expandDateKeys,
    }
    return await mobileApiRequest(action)
}

export const getTablePreviewData = async (reportSeriesTableID, latestLoad) => {
    const action = {
        action: 'reportSeriesTablePreviewData',
        inputQuery: {
            tableID: reportSeriesTableID,
            useLatestLoad: latestLoad,
        },
    }
    const previewData = await mobileApiRequest(action)
    return previewData
}

export const getIngestionMetadata = async (inboxID) => {
    const action = {
        action: 'getIngestionMetadata',
        inboxID,
    }
    return await mobileApiRequest(action)
}

export const getReportStatus = async (inboxID) => {
    const action = {
        action: 'getObjects',
        class: 'scoop.reportseriestable.ReportSeriesTable',
        attributeName: 'inboxID',
        attributeValue: inboxID,
        isDev: process.env.REACT_APP_SCOOP_ENV === 'dev',
    }
    return await mobileApiRequest(action)
}

export const getEventLogItems = async (inboxID) => {
    const action = {
        action: 'getEventLogItems',
        inboxID,
    }
    const result = await mobileApiRequest(action)
    return result?.eventLogItems?.filter((log) => log.inboxID === inboxID) || []
}

export const deleteEventLog = async (inboxID, deleteLog) => {
    const action = {
        action: 'deleteIngestion',
        inboxID,
        ...(deleteLog.rstiKey ? { rstiKey: deleteLog.rstiKey } : { s3Key: deleteLog.s3key }),
    }
    return await mobileApiRequest(action)
}

export const getProcessStatus = async () => {
    const action = {
        action: 'getProcessStatus',
    }
    return await mobileApiRequest(action)
}

export const deleteTable = async (reportSeriesTableID) => {
    if (!reportSeriesTableID) return
    const action = {
        action: 'delete',
        reportSeriesTableID,
        deleteAll: true,
    }
    return await mobileApiRequest(action)
}

export const getTableData = async (reportSeriesTableID) => {
    const action = {
        action: 'getObject',
        key: reportSeriesTableID,
        class: 'scoop.reportseriestable.ReportSeriesTable',
    }
    return await mobileApiRequest(action)
}

export const renameTable = async (reportSeriesTableID, newName, ignoreTable) => {
    const tableMetadata = await getTableData(reportSeriesTableID)
    if (!tableMetadata) return
    tableMetadata.metadata.tableName = newName
    tableMetadata.metadata.ignoreTable = ignoreTable
    const action = {
        action: 'putObject',
        class: 'scoop.reportseriestable.ReportSeriesTable',
        key: reportSeriesTableID,
        value: tableMetadata,
    }
    return await mobileApiRequest(action)
}

export const getInboxData = async (inboxName) => {
    const action = {
        action: 'getObject',
        key: inboxName,
        class: 'scoop.ingest.ReportInbox',
    }
    return await mobileApiRequest(action)
}

export const saveInboxData = async (inboxName, value) => {
    const action = {
        action: 'putObject',
        key: inboxName,
        class: 'scoop.ingest.ReportInbox',
        value: value,
    }
    return await mobileApiRequest(action)
}

export const updateDatasetSemantics = async (inboxID, forceRefresh = false, initialSemantics) => {
    const action = {
        action: 'updateDatasetSemantics',
        inboxID,
        forceRefresh,
    }
    if (initialSemantics) {
        action.initialSemantics = initialSemantics
    }
    return await mobileApiRequest(action)
}
